import { defineStore } from 'pinia';
import { getTiandituKey } from '@/api/console';

export const useMapStore = defineStore('map', {
  state: () => ({
    mapLoadingStatus: '', // 地图加载状态: success加载成功 fail加载失败
  }),
  actions: {
    // 登录成功动态加载地图资源
    loadMap() {
        if (window.localStorage.getItem('vmp-tianditu-key')) {
            this.loadMapFun(window.localStorage.getItem('vmp-tianditu-key'));
        } else {
            getTiandituKey().then((key) => {
                window.localStorage.setItem('vmp-tianditu-key', key);
                
                this.loadMapFun(key);
            })
        }
    },
    loadMapFun (tiandituKey) {
        const that = this;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${tiandituKey}`;
        document.head.appendChild(script);

        script.onload = function () {
            console.log('== Map Load Success ==')
            setTimeout(() => {
                that.mapLoadingStatus = 'success';
            }, 200)
        }

        script.onerror = function() {
            console.error('== Map Load Fail ==');
            that.mapLoadingStatus = 'fail';
        };
    }

  },
});


// WEBPACK FOOTER //
// ./src/pinia/map.js